import { createApiSlice } from "@common";
import { CRUD_MARKET } from "@routes";

const apiConfig = [
  {
    name: "addMarket",
    method: "post",
    url: CRUD_MARKET,
    stateKey: "message",
  },
  {
    name: "getMarket",
    method: "get",
    url: CRUD_MARKET,
    stateKey: "data",
  },
  {
    name: "updateMarket",
    method: "put",
    url: CRUD_MARKET,
    stateKey: "message",
  },
  {
    name: "deleteMarket",
    method: "delete",
    url: CRUD_MARKET,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"market",
 apiConfig, 
 customReducers);
const marketSlice = slice;

export default marketSlice.reducer;

export const {
  addMarket,
  getMarket,
  updateMarket,
  deleteMarket,
} = thunks;

export const { rowSelect } = actions;
